export default __webpack_public_path__ + "static/logo-nom-v4-b13241d3f776f17deb0547d59b0f164a.png";